import axios from "axios";

var axiosAuth = axios.create({
  baseURL: process.env.REACT_APP_API + "/app/auth",
  timeout: 15000,
});

export default axiosAuth;
